// AUTO-GENERATED from services/app-api-service/codeigniter/application/contracts/AdditionalServices_ListaPorCategoriaResponse.php
// Do not edit by hand — edit the PHP ResponseContract and the sync hook will regenerate this file.
// Bulk regeneration: scripts/sync-contracts/sync-all.sh

/**
 * Response contract for GET /so/additional_services/lista_por_categoria/{categoryId}.
 *
 * Returns the list of active additional services filtered by service category.
 * The row shape is identical to /so/additional_services/lista because both
 * endpoints select via the same columns (see So_additional_services_model::listByCategory()
 * and listAll()) and apply the same controller-side mutations
 * (price cents → currency float, created_at GMT-3 → ISO 8601 UTC).
 */
import type { AdditionalServices_ListaRow } from './AdditionalServices_ListaRow'
import type { ApiResponse } from '../services/httpService'
import { registerResponseContract } from './validate'

export type AdditionalServices_ListaPorCategoriaResponseDados = AdditionalServices_ListaRow[];

export type AdditionalServices_ListaPorCategoriaResponse = ApiResponse<AdditionalServices_ListaPorCategoriaResponseDados>;

registerResponseContract('AdditionalServices_ListaPorCategoriaResponse', {
  _root: {
    type: 'array',
    required: true,
    items: {
      so_additional_service_id:                       { type: 'number',  required: true },
      so_additional_service_category_id:              { type: 'number',  required: true },
      so_additional_service_name:                     { type: 'string',  required: true },
      so_additional_service_description:              { type: 'string',  required: false },
      so_additional_service_default_price:            { type: 'number',  required: true },
      so_additional_service_additional_deadline_days: { type: 'number',  required: false },
      so_additional_service_active:                   { type: 'number',  required: true },
      so_additional_service_created_at:               { type: 'string',  required: false },
      so_service_category_name:                       { type: 'string',  required: false },
      category_name:                                  { type: 'string',  required: false },
      so_additional_service_franchise_id:             { type: 'number',  required: false },
    },
  },
})
